import apiOnboarding from '../apiOnboarding'
import apiSparkle from '../apiSparkle'
import { OnboardingEndpoints } from './constants'
import {
  PutOnboardingProps,
  ResponseGetOnboarding,
  GetOnboardingIA,
  ResponseGetOnboardingIA
} from './types'

class OnboardingService {
  static async getOnboarding(idCommunity: number) {
    const { data } = await apiOnboarding.get<ResponseGetOnboarding>(
      OnboardingEndpoints.getOnboarding(idCommunity)
    )

    return data
  }

  static async putOnboarding({ idCommunity, stepOnboarding, payload }: PutOnboardingProps) {
    const { data } = await apiOnboarding.put<void>(
      OnboardingEndpoints.putOnboarding(idCommunity, stepOnboarding),
      payload
    )

    return data
  }

  static async getOnboardingIA({ promptType, locale }: GetOnboardingIA) {
    const params = {
      prompt: promptType,
      locale: locale.toLocaleLowerCase()
    }

    const { data } = await apiSparkle.get<ResponseGetOnboardingIA>(
      OnboardingEndpoints.getOnboardingIA(),
      {
        params
      }
    )

    return data
  }
}

export default OnboardingService
